import { render, staticRenderFns } from "./DepartmentSelect.vue?vue&type=template&id=822038e4&scoped=true"
import script from "./DepartmentSelect.vue?vue&type=script&lang=js"
export * from "./DepartmentSelect.vue?vue&type=script&lang=js"
import style0 from "./DepartmentSelect.vue?vue&type=style&index=0&id=822038e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "822038e4",
  null
  
)

export default component.exports